const ETHNICITY_OPTIONS = [
  'Hispanic, Latino, or Spanish',
  'Not Hispanic, Latino, or Spanish',
  'Not specified',
];

export default ETHNICITY_OPTIONS;
